module.exports = __webpack_public_path__ + "img/github_login.0828ec37.svg";